/**
 * Within the legalzoom tealium organization there are multiple profiles.
 * Each profile has its own set of tags, and to switch profiles requires a full page refresh.
 */
export const TealiumProfiles = {
  MAIN: 'main',
  TAX: 'tax',
} as const;

export type TealiumProfile =
  (typeof TealiumProfiles)[keyof typeof TealiumProfiles];
